'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import * as gtag from '@/lib/gtag';

export default function GoogleAnalytics() {
  const pathname = usePathname();
  const search = useSearchParams();

  useEffect(() => {
    if (!gtag.GA_MEASUREMENT_ID) return;
    const url = pathname + (search ? `?${search.toString()}` : '');
    gtag.pageview(url);
  }, [pathname, search]);

  return null;
}

